export const EEC_ACCESSORIES_IMPRESSIONS_FROM_CART = 'EEC_Cart_Accessories_Impressions';
export const EEC_ACCESSORIES_ARRAY_AVAILABLE_FROM_CART = 'EEC_Cart_Accessories_Array_Available';
export const EEC_ACCESSORY_COLOR_CHANGE = 'EEC_Cart_Accessory_ColorChanged';
